import { determineMapServicePermission } from "@/utils/determineMapServicePermission";
import { useState, useEffect } from "react";

export const useMapServicePermission = (): [boolean | null, boolean] => {
  const [hasPermission, setHasPermission] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const appId = localStorage.getItem("mapServiceAppId");
    const trialStartDate = localStorage.getItem("mapServiceTrialStartDate");
    const trialEndDate = localStorage.getItem("mapServiceTrialEndDate");
    const contractStartDate = localStorage.getItem(
      "mapServiceContractStartDate"
    );

    const permission = determineMapServicePermission({
      appId: appId ?? null,
      contractStartDate: contractStartDate ?? null,
      trialStartDate: trialStartDate ?? null,
      trialEndDate: trialEndDate ?? null,
    });
    setHasPermission(permission);
    setLoading(false);
  }, []);

  return [hasPermission, loading];
};
